import React, { useState } from "react";
import { RefreshCw } from "lucide-react";

export default function RefreshButton({ onRefresh, spinning = false }) {
  const [hovered, setHovered] = useState(false);

  return (
    <button
      type="button"
      onClick={onRefresh}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      aria-label="refresh"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 34,
        height: 34,
        borderRadius: "50%",
        background: hovered ? "rgba(255,255,255,0.06)" : "transparent",
        border: "none",
        color: hovered ? "#fff" : "#c3c8cc",
        cursor: "pointer",
        flexShrink: 0,
        transition: "background 0.15s, color 0.15s",
      }}
    >
      <RefreshCw size={15} className={spinning ? "tw-animate-spin" : ""} />
    </button>
  );
}
